import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@vc/ui/tipos.css";
import "@vc/ui/tokens.css";
import "@vc/ui/base.css";
import "./landing.css";

import { App } from "./App.tsx";

const raiz = document.getElementById("raiz");
if (!raiz) throw new Error("Falta #raiz en index.html");
createRoot(raiz).render(<StrictMode><App /></StrictMode>);
